import React from 'react';
import Loadable from 'react-loadable';
import { Route, Switch } from 'react-router-dom';

import PageLayout from '../layouts/PageLayout';

// Main Container/jsx Displayed on the page
const CheckoutContainer = Loadable({
  loader: () => import('../containers/checkout'),
  loading: () => null,
});

export default function (store: any, props: any) {
  // call Register Reducer here
  const match = props.match;

  const renderFunction = (props: any) => {
    const more = {
      ...props,
    };
    return <CheckoutContainer {...more} />;
  };

  return (
    <Switch>
      <PageLayout>
        <Route
          path={ match.url }
          render={ renderFunction }
        />
      </PageLayout>
    </Switch>
  );
}
